import { useCallback } from 'react'
import { useAmplitude } from 'react-amplitude-hooks'

import { useConsoleLogger } from './useConsoleLogger'

/*
  A Logging Sink where we could log the same event to multiple providers.
  Don't use this as a replacement for console.log during general debugging though
  as that would send all those logs to amplitude. 
*/

export type LoggerEvent =
  | 'Clicked on pay now button'
  | 'Payment challenge Modal Opened'
  | 'Payment challenge Modal Loaded'
  | 'Payment challenge Modal Closed'
  | 'Payment challenge is slow to load'
  | 'Payment Error'
  | 'Clicked on Add a new card button'
  | 'Clicked on Start a new tab button'
  | 'Updated embedded table number'
  | 'Eonx check in success'
  | 'Eonx check in failure'
  | 'Eonx check in ID found'
  | 'View login page'
  | 'View SMS code page'
  | 'View venue categories'
  | 'View menu'
  | 'View bill cart'
  | 'View cart'
  | 'View order confirmation'
  | 'View shared payment confirmation'
  | 'View multi vendor order confirmation'
  | 'View payment options'
  | 'Changed payment type'
  | 'View shared payment'
  | 'View wallet options'
  | 'Payment intent ID does not match verification ID'
  | 'View new payment page'

export type LoggerPayload = { [key: string]: any }

export const useLogger = (eventProperties: LoggerPayload = {}) => {
  const { logEvent } = useAmplitude(eventProperties)
  const { logToConsole } = useConsoleLogger()

  const sendLog = useCallback(
    (event: LoggerEvent, payload: LoggerPayload = {}) => {
      logEvent(event, payload)
      logToConsole(event, { ...eventProperties, ...payload })
    },
    [logEvent, logToConsole, eventProperties],
  )

  return {
    sendLog,
  }
}
